const NONE = '';
const ORGANIZATION = 'owner';
const ADMINISTRATOR = 'administrator';
const REPRESENTATIVE = 'proxy';

const applicationRoles = { NONE, ORGANIZATION, ADMINISTRATOR, REPRESENTATIVE };
export default applicationRoles;
